var BY_SKILL = {
  Listening: {
    'Multiple Choice': '听力选择题',
    'Fill in the Blanks': '听力填空'
  },
  Reading: {
    'Multiple Choice': '阅读选择',
    'Letter Match': '字母匹配',
    'Word-Picture Match': '图词匹配',
    'Sentence-Picture Match': '图句匹配',
    'True/False Judgment': '判断题',
    'Cloze': '完形填空',
    'Gap Fill': '选词填空',
    'Reading Comprehension': '阅读理解',
    'Multiple Choice - Reading Comprehension': '阅读理解选择',
    'Advanced Reading': '进阶阅读',
    'Information Matching': '信息匹配'
  },
  Writing: {
    'Drag Letters - Picture Spelling': '拖字母-看图拼写',
    'Drag Letters - Audio Spelling': '拖字母-听音拼写',
    'Drag Letters - Sentence Completion': '拖字母-补全句子',
    'Typing - Picture Spelling': '打字-看图拼写',
    'Typing - Audio Spelling': '打字-听音拼写',
    'Typing - Sentence Completion': '打字-补全句子',
    'Typing - Dialogue Completion': '打字-补全对话',
    'Sequence - Sentence Ordering': '句子排序',
    'Fill Passage - Word Form': '语篇填空-词形',
    'Fill in Blank - Word Form': '单空填空-词形',
    'Picture Writing - 3 to 4 Sentences': '看图写 3-4 句',
    'Picture Writing - Four Panel Story': '四格故事写作',
    'Practical Writing - Reply Letter': '应用文-回信',
    'Guided Writing - Email': '引导写作-邮件'
  },
  Speaking: {
    'Oral Letter Reading': '字母认读',
    'Letter Sound': '字母发音',
    'Picture Naming': '看图说词',
    'Word Blending': '单词拼读',
    'Simple Q&A': '简单问答',
    'Picture Q&A': '看图问答',
    'Picture Description': '看图描述',
    'Self Introduction': '自我介绍',
    '1-min Presentation': '一分钟陈述',
    'Discussion': '观点讨论',
    'Story Telling With Picture': '看图讲故事',
    'Topic Talk': '话题表达'
  }
}

var SHARED = {}
Object.keys(BY_SKILL).forEach(function (skill) {
  var map = BY_SKILL[skill]
  Object.keys(map).forEach(function (code) {
    if (!SHARED[code]) SHARED[code] = map[code]
  })
})

function hasCjk (s) {
  return /[\u4e00-\u9fff]/.test(s || '')
}

export function questionTypeLabel (code, skill) {
  let value = String(code || '').trim()
  if (!value) return ''
  if (hasCjk(value)) return value
  let cn = (BY_SKILL[skill] && BY_SKILL[skill][value]) || SHARED[value]
  if (!cn) return value
  return cn + ' ' + value
}

export function skillLabel (code) {
  if (code === 'Listening') return '听力 Listening'
  if (code === 'Speaking') return '口语 Speaking'
  if (code === 'Reading') return '阅读 Reading'
  if (code === 'Writing') return '写作 Writing'
  return code || ''
}

export function catReasonLabel (code) {
  let v = String(code || '').trim()
  if (!v) return ''
  if (v === 'ANCHOR' || v.indexOf('ANCHOR') >= 0) return '锚题'
  if (v === 'SLOT') return '槽位'
  if (v === 'PRACTICE') return '练习'
  if (v === 'FIXED_FORM') return '固定卷'
  return v
}



// WEBPACK FOOTER //
// ./src/components/mex/mex-question-type.js